import script from "./WeeklyAggregationRow.vue?vue&type=script&setup=true&lang=ts"
export * from "./WeeklyAggregationRow.vue?vue&type=script&setup=true&lang=ts"

import "./WeeklyAggregationRow.vue?vue&type=style&index=0&id=22ffed88&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-22ffed88"]])

export default __exports__